import { Injectable } from '@angular/core';
import { DataDictionary, DdContextEntriesMap, DdEntryMerged } from '../../model/data-dictionary';

import * as _ from 'lodash';

/**
 * Service zur Abfrage des HISinOne DataDictionary.
 * Beim DataDictionary handelt es sich um Metadaten, die sich in der Regel auf Entity-Attribute beziehen.
 * Über die Metadaten können z.B. einfache Validierungen deklariert werden.
 */
@Injectable({providedIn: 'root'})
export class HisDdService {
    private dd: DataDictionary = {};

    constructor() {
    }

    setDd( dd: DataDictionary ) {
        console.log( 'HisDdService: set dd' );
        this.dd = dd;
    }

    setDdEntry(key: string, entry: DdEntryMerged, context?: string) {
        let contextMetas: DdContextEntriesMap = this.dd[key];
        if ( !contextMetas ) {
            contextMetas = this.dd[key] = {};
        }
        if ( !context || context.length === 0 ) {
            context = 'DEFAULT';
        }
        contextMetas[context] = entry;
    }

    /**
     * Sets required to the DD entry with the given key, for all contexts.
     *
     * @param key the DD key
     * @param value the required value to set
     */
    setRequiredToDdEntry( key: string, value: boolean ) {
        let contextMetas: DdContextEntriesMap = this.dd[key];
        if ( !contextMetas ) {
            contextMetas = this.dd[key] = {};
        }
        if ( Object.keys( contextMetas ).length === 0 ) {
            let ddEntry = new DdEntryMerged();
            ddEntry.identifier = key;
            contextMetas.DEFAULT = ddEntry;
        }
        for ( let context of Object.keys( contextMetas ) ) {
            let ddEntry: DdEntryMerged = contextMetas[context];
            ddEntry.required = value;
        }
    }

    /**
     * Sets required to the DD entry with the given key and the given context.
     *
     * @param key the DD key
     * @param value the required value to set
     * @param context the context
     */
    setRequiredToDdEntryContext( key: string, value: boolean, context: string ) {
        let contextMetas: DdContextEntriesMap = this.dd[key];
        if ( !contextMetas ) {
            contextMetas = this.dd[key] = {};
        }
        let ddEntry = contextMetas[context];
        if ( !ddEntry ) {
            ddEntry = contextMetas[context] = new DdEntryMerged();
            ddEntry.identifier = key;
        }
        ddEntry.required = value;
    }

    getMergedEntry( ddKey: string, contexts?: string[] ): DdEntryMerged {
        let contextMetas: DdContextEntriesMap = this.dd[ddKey];
        if ( !contextMetas ) {
            return null;
        }

        // contexts sollen immer DEFAULT als erstes Element enthalten
        if ( !contexts || contexts.length === 0 ) {
            contexts = ['DEFAULT'];
        } else if (contexts[0] !== 'DEFAULT') {
            contexts = ['DEFAULT', ...contexts];
        }

        let ddMerged = new DdEntryMerged();
        for ( let context of contexts ) {
            let ddEntry = contextMetas[context];
            if ( ddEntry ) {
                //ddEntry = this.setUndefinedBooleanAtttributeValue( ddEntry );
                _.merge( ddMerged, ddEntry ); // modifies ddMerged
            }
        }
        return ddMerged;
    }

    /**
     * Returns the (unmerged) DD entry for exactly the given context, without falling back to or merging with
     * 'DEFAULT'. Used to determine whether an explicit configuration exists for a specific context, e.g. to
     * decide whether to show an "edit" or an "add" link for the data dictionary configuration of that context.
     *
     * @param ddKey the DD key
     * @param context the context to look up (defaults to 'DEFAULT')
     */
    getEntryForContext( ddKey: string, context?: string ): DdEntryMerged {
        let contextMetas: DdContextEntriesMap = this.dd[ddKey];
        if ( !contextMetas ) {
            return null;
        }
        if ( !context || context.length === 0 ) {
            context = 'DEFAULT';
        }
        return contextMetas[context] || null;
    }

    /** sets DdEntryMerged boolean properties where values are undefined explizit to false */
    private setUndefinedBooleanAtttributeValue( ddEntry: DdEntryMerged ): DdEntryMerged {
        DdEntryMerged.allDdBooleanAttributes.forEach( ( booleanAttribute: string ) => {
            if( ( ddEntry as any )[booleanAttribute] === undefined ) {
                ( ddEntry as any )[booleanAttribute] = false;
            }
        } );
        return ddEntry;
    }

}
